import appConfigs from "@configs/app";
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      avatarBackgroundUrl: "",
    };
  },
  methods: {
    getPresetsUrlFromFilename(fileName) {
      //fileName here does not contain extension
      return `${appConfigs.s3ResourceDomain}/avatar/user/presets/${fileName}.svg`;
    },
    getUserAvatarUrlFromFilenameAndVersion(fileName, fileVersion) {
      //fileName here does not contain extension
      //when user's avatar is default one, its url will be located under this path of resource bucket:
      // /avatar/user/default_student.svg
      //when user's avatar is not default one,
      // /avatar/user/avatar_uuid/avatar_file_version/avatar_uuid.svg
      if (fileName.startsWith("default")) {
        return `${appConfigs.s3ResourceDomain}/avatar/user/${fileName}.svg`;
      } else {
        return `${appConfigs.s3ResourceDomain}/avatar/user/${fileName}/${fileVersion}/${fileName}.svg`;
      }
    },
    getAvatarElementUrlFromFilename(type, fileName) {
      //fileName here contains extension
      return `${appConfigs.vleDomain}/avatar/element/${type}/${fileName}`;
    },
    getAvatarBackgroundUrl() {
      if (this.isStudent) {
        return `${appConfigs.vleDomain}/avatar/element/background/student_bg.svg`;
      } else {
        return `${appConfigs.vleDomain}/avatar/element/background/teacher_bg.svg`;
      }
    },
  },
  computed: {
    ...mapGetters("auth", ["isStudent"]),
  },
  created() {
    this.avatarBackgroundUrl = this.getAvatarBackgroundUrl();
  },
};
